$(document).ready(function () {

    // show hide password recovery
    $('.js-toggle-show').on('click', function (event) {
        event.preventDefault();
        var $this = $(this);

        $($this.attr('data-show')).slideDown();
        $($this.attr('data-hide')).slideUp();
    });



    $('#password-recover-form').submit(function(event) {
        event.preventDefault();

        var $form = $(this);

        var email = $form.find('#recoveremail').val();
        var password = $form.find('#recoverpassword').val();

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data : {
                email : email,
                password : password
            },
            dataType: 'json',
            beforeSend: function(data) {
                $form.find(':input').prop('disabled', true);
            },
            success: function(data) {
                if (data.success) {
                    const $tokenForm = $('#password-new-form-token');
                    $form.addClass('hide')
                    $tokenForm.removeClass('hide')
                    copyFormInputs('#password-recover-form', '#password-new-form-token', {
                        'recoveremail': 'email'
                    });
                    showMessageBox('success', msg['MSG_TOKEN_SENT']);
                }
                else {
                    showMessageBox('danger', msg[data.errors.message] || msg['MSG_GENERIC_ERROR']);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                $form.find(':input').prop('disabled', false);
            }
        });
    });

    $('#password-new-form-token').on('submit', function(event) {
        event.preventDefault();
    
        var $form = $(this);
    
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {
                $form.find(':input').prop('disabled', true);
            },
            success: function(data) {
                if (data.success) {
                    showMessageBox('success', msg['MSG_PASSWORD_OK']);
                    setTimeout(function(){
                        window.location.href = $form.data('nexturl');
                    },2000)
                } 
                else if (data.errors.message == 'fault') {
                    showMessageBox('danger', msg['ERR_WRONG_TOKEN']);
                }
                else if (data.errors.message == 'login.user.passwordnotcomplexenought') {
                    $('#password-new-form-token #password').siblings('.form-error').text(msg['MSG_PSW_COMPLEX_INSTRUCTIONS']).css('display', 'block')                    
                }
                else {
                    showMessageBox('danger', msg[data.errors.message] || msg['MSG_GENERIC_ERROR']);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                $form.find(':input').prop('disabled', false);
                showMessageBox('success', msg[data.errors.message]);
            }
        });
    });

    function copyFormInputs(sourceForm, destForm, nameMap) {
        const source = $(sourceForm);
        const dest = $(destForm);
    
        for (const [sourceName, destName] of Object.entries(nameMap)) {
            const sourceInput = source.find(`[name=${sourceName}]`);
            const destInput = dest.find(`[name=${destName}]`);
    
            if (exists(sourceInput) && exists(destInput)) {
                destInput.val(sourceInput.val()).trigger('change');
            }
        }
      }
    
      function exists(selector) {
        try {
            return $(selector).length > 0;
        }
        catch {
            return false;
        }
      }

    $('#subscribe-form').submit(function(event) {
        event.preventDefault();

        var $form = $(this);

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {
                $form.find(':input').prop('disabled', true);
            },
            success: function(data) {
                if (data.success) {
                    if (window.dataLayer) {
                        pushGTMEventWithCallback(500, {
                            event: 'sign_up',
                            eventCallback: GTMCallback(function() {
                                window.location = $form.data('redirectsuccess');
                            })
                        })
                    }
                    else {
                        window.location = $form.data('redirectsuccess');
                    }
                }
                else {
                    showMessageBox('danger', msg[data.errors.message]);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                $form.find(':input').prop('disabled', false);
            }
        });
    });

});